import { COLORS } from "shared/consts";
import { toRem } from "shared/helpers";
import styled from "styled-components";

export const HivesFiltersItem = styled.div`
    background-color: ${COLORS.BG.ELEVATED.M};
    padding: ${toRem(16)};
    border-radius: ${toRem(16)};
    box-shadow: 0px 2px 4px 0px ${COLORS.NEUTRAL.CONTAINER_SOFT},
    0px 0px 8px 0px ${COLORS.NEUTRAL.CONTAINER_MUTED};

    .input.input--size-m.input--textarea {
        margin-top: ${toRem(22)};
    }

    textarea {
        border-radius: ${toRem(8)};
        border: ${toRem(2)} solid ${COLORS.BORDER.MUTED};
        resize: none;
        min-height: ${toRem(80)};
        padding: ${toRem(8)} ${toRem(12)};
        font-size: ${toRem(14)};
        line-height: ${20 / 14};
    }
`;

export const HivesFiltersItemTitle = styled.h3`
    font-weight: 700;
    font-size: ${toRem(16)};
    line-height: ${20 / 16};
    color: ${COLORS.FG.DEFAULT};
    display: flex;
    justify-content: space-between;
    gap: ${toRem(12)};

    &:not(:last-child) {
        margin-bottom: ${toRem(16)};
    }

    button {
        color: ${COLORS.ACCENT.DEFAULT};
        transition: color 0.3s ease 0s;

        @media (any-hover: hover) {
            &:hover {
                color: ${COLORS.ACCENT.HOVER};
            }
        }
    }
`;

export const HivesFiltersRangeItemBody = styled.div`
    display: flex;
    gap: ${toRem(12)};

    .input {
        min-width: 0;
    }
`;

export const HivesFiltersRangeItemFooter = styled.div`
    padding-top: ${toRem(12)};
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: ${toRem(16)};
`;
